angular.module('dnecom')
    .controller('IntegrationsModalController', ["$scope", "$uibModalInstance", "$http", "$timeout", "notifications", "account", "settings", "WindowUtils", "paystackCurrencies", function($scope, $uibModalInstance, $http, $timeout, notifications, account, settings, WindowUtils, paystackCurrencies) {
        $scope.account = angular.copy(account);
        $scope.settings = angular.copy(settings);
        $scope.paystackCurrencies = paystackCurrencies;
        $scope.hideCurrencySelect = account.properties ? account.properties.currency : false;
        $scope.activeTypes = TemplateData.value('activeTypes');

        $scope.authorizing = false;
        $scope.videoVisible = false;

        $scope.timeout = null;

        function scheduleCheck(method, timeout) {
            $scope.timeout = setInterval(method, timeout || 3000);
        }

        function descheduleCheck() {
            clearInterval($scope.timeout);

            $scope.timeout = null;
        }

        var authTimer = null;
        var GOOGLE_AUTH_CHECK_TIMEOUT = 3000; // 3 seconds

        /**
         * Instance for opened window.
         *
         * @type {null}
         */
        var googleAuthWindow = null;

        /**
         * Timeout for window check.
         *
         * @type {undefined}
         */
        var googleAuthWindowTimeout = undefined;

        /**
         * Timeout for window check.
         *
         * @type {number}
         */
        var GOOGLE_AUTH_WINDOW_CHECK_TIMEOUT = 500;

        $scope.googleAuthInProgress = false;

        $scope.validateForm = function(form) {
            if (form.$invalid || form.$pending) {
                form.$setTouched();

                return false;
            }

            return true;
        };

        $scope.saveAccount = function(form) {
            if (!$scope.validateForm(form)) {
                return;
            }

            $uibModalInstance.close($scope.account);
        };

        $scope.saveXomatorSettings = function(form) {
            if (!$scope.validateForm(form)) {
                return;
            }

            $uibModalInstance.close(angular.merge({
                'type': 'xomator'
            }, $scope.settings));
        };

        $scope.authorizeAweberAccount = function() {
            $scope.authorizing = true;

            var openedWindow = WindowUtils.openBlank('about:blank', {
                width: 630,
                height: 400
            });

            openedWindow.document.write('Waiting for response...');
            openedWindow.document.close();

            $http
                .post(Routing.generate('integrations_aweber_authorize'), $scope.account)
                .then(function(response) {
                    if (!response.data.success || !response.data.authUrl || !response.data.account) {
                        openedWindow.close();
                        notifications.danger(response.data.message || 'Unknown error.');
                        $scope.authorizing = false;
                        return;
                    }

                    $scope.account = response.data.account;
                    openedWindow.location.href = response.data.authUrl;
                    scheduleCheck($scope.checkAweberStatus);
                }, function() {
                    openedWindow.close();
                    $scope.authorizing = false;
                    notifications.danger('Request error.');
                })
            ;
        };

        $scope.checkAweberStatus = function() {
            if (!$scope.authorizing) {
                return;
            }

            $http
                .post(Routing.generate('integrations_aweber_check_status'), {
                    'id': $scope.account.id,
                })
                .then(function(response) {
                    if (!response.data.success || $scope.timeout === null) {
                        return;
                    }

                    descheduleCheck();
                    $scope.account = response.data.account;
                    $scope.authorizing = false;
                    $scope.resolveModal($scope.account);
                })
            ;
        };

        $scope.cancelAweberAuthorize = function() {
            $scope.authorizing = false;
        };

        $scope.authenticateGoogleAccount = function() {
            if (!$scope.account.properties.clientId || !$scope.account.properties.clientSecret) {
                return;
            }

            $scope.googleAuthInProgress = true;

            googleAuthWindow = WindowUtils.openBlank('about:blank', {
                width: 640,
                height: 460
            });

            googleAuthWindow.document.write('Waiting for response...');
            googleAuthWindow.document.close();

            $http
                .post(Routing.generate('integrations_google_auth_init'), $scope.account)
                .success(function(response) {
                    if (!response.success) {
                        googleAuthWindow.close();
                        alert(response.error || 'Failed to authenticate.');
                        $scope.googleAuthInProgress = false;
                        return;
                    }

                    if (!$scope.googleAuthInProgress) {
                        return;
                    }

                    var scope = 'https://www.googleapis.com/auth/analytics.readonly';

                    var authUrl = 'https://accounts.google.com/o/oauth2/auth?';
                    authUrl += 'client_id=' + $scope.account.properties.clientId;
                    authUrl += '&redirect_uri=' + window.location.origin + Routing.generate('integrations_google_auth_callback');
                    authUrl += '&response_type=code&scope=' + encodeURIComponent(scope) + '&approval_prompt=force&access_type=offline';

                    googleAuthWindow.location.href = authUrl;

                    googleAuthWindowTimeout = setTimeout(checkGoogleAuthWindow, GOOGLE_AUTH_WINDOW_CHECK_TIMEOUT);

                    scheduleCheck($scope.checkGoogleAuthStatus, GOOGLE_AUTH_CHECK_TIMEOUT);
                })
                .error(function(response) {
                    googleAuthWindow.close();
                    $scope.googleAuthInProgress = false;
                    alert(response.message || 'Failed to authenticate.');
                })
            ;
        };

        $scope.checkGoogleAuthStatus = function() {
            $http
                .post(Routing.generate('integrations_google_auth_check_status'))
                .success(function(response) {
                    if (!response || !response.success) {
                        alert(response.message || 'Failed to check authentication status.');
                    }

                    if (response.authCancelled) {
                        $scope.cancelGoogleAuthCheck();
                        return;
                    }

                    if (response.oauth) {
                        descheduleCheck();
                        $scope.googleAuthInProgress = false;
                        $scope.account.properties.oauthResponse = response.oauth;

                        // for some reason this input doesn't reflect changes in model, so it has to be updated manually
                        $('#youtube_account_oauth_response').val(response.oauth);
                    }
                })
            ;
        };

        $scope.cancelGoogleAuthCheck = function(event) {
            if (event) {
                event.preventDefault();
            }

            descheduleCheck();
            $scope.googleAuthInProgress = false;
        };

        $scope.deauthenticateGoogleAccount = function() {
            $scope.account.properties.oauthResponse = null;
        };

        $scope.toggleVideo = function() {
            $scope.videoVisible = !$scope.videoVisible;
        };

        $scope.resolveModal = function(result) {
            $uibModalInstance.close(result);
        };

        $scope.closeModal = function(result) {
            $uibModalInstance.dismiss(result);
        };

        /**
         * Check if auth window is closed or not.
         */
        var checkGoogleAuthWindow = function () {
            clearTimeout(googleAuthWindowTimeout);

            if ((!googleAuthWindow || googleAuthWindow.closed == true) && $scope.account.properties.oauthResponse == null) {
                $timeout(function () {
                    $scope.cancelGoogleAuthCheck();
                });
                return;
            }

            googleAuthWindowTimeout = setTimeout(checkGoogleAuthWindow, GOOGLE_AUTH_WINDOW_CHECK_TIMEOUT);
        };

        $scope.addMcAfeeAccount = function(form) {
            if ($scope.account.id) { // no edit account method available in mcafee API
                return;
            }

            if (!$scope.validateForm(form)) {
                return;
            }

            $scope.adding = true;

            $http.post(Routing.generate('integrations_mcafee_add', {}), $scope.account)
                .then(function(response) {
                    if (response.data.success) {
                        $scope.account = response.data.account;
                        $scope.adding = false;
                        $uibModalInstance.close($scope.account);
                        return;
                    }

                    notifications.danger(errors.join(', '));
                }, function(response) {
                    if (response.hasOwnProperty('data') && response.data.hasOwnProperty('errors')) {
                        var errors = [];
                        for (var key in response.data.errors) {
                            errors.push(response.data.errors[key]);
                        }
                        notifications.danger(errors.join(', '));
                    } else {
                        notifications.danger('Request error.');
                    }
                }).finally(function() {
                    $timeout(function() {
                        $scope.adding = false;
                    });
                })
            ;
        };

        $scope.getCurrencyName = function (currency) {
            let name = ''
            $scope.paystackCurrencies.forEach(function (item){
                if (currency === item.code) {
                    name = item.name;
                }
            })

            return name;
        };

        $scope.removeDefaultCurrency = function () {
            $scope.hideCurrencySelect = false;
        };
    }])
;